var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkRNv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0;}.b{fill:#002445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-341 -3612)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 24,
    transform: "translate(341 3612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,9.987a1.5,1.5,0,0,1-1.5-1.5L-1.5,0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0l0,8.487A1.5,1.5,0,0,1,0,9.987Z",
    transform: "translate(345.998 3618.002) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,1.5A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5l8.487,0A1.5,1.5,0,0,1,9.987,0a1.5,1.5,0,0,1-1.5,1.5L0,1.5Z",
    transform: "translate(345.998 3629.998) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkRNv);
export default __webpack_public_path__ + "static/media/icon_link_r_nv.a1f3798e0c546bf70d189907ca02a46e.svg";
export { ForwardRef as ReactComponent };